import axios from "axios";
import Swal from "sweetalert2"
import { rotaDeProducao } from "./rotas";



/**
 * Busca o status da mesa ou do cartao
 * @param {String} cnpj 
 * @param {int} idTerminal 
 * @param {int} numeroEmpresaFK 
 * @returns {Object}   {"Id": 1,"numero_mesa": 22,"status": "LIVRE","valor_total": null} 
 */
export async function apiBuscarStatusMesa(cnpj, idTerminal, numeroEmpresaFK, numeroCartao) {
    
    let cnpjConvertido = cnpj.replaceAll(",", "").replaceAll(".", "").replaceAll("-", "").replaceAll("/", "");

    try {
        // para testes --> cnpj=00906885019092 idTerminal=72
        let urlProd = null
        if (numeroCartao != null) {
            urlProd = rotaDeProducao() +"/statuscartao?cnpj=" + cnpjConvertido + "&idTerminal=" + idTerminal + "&numeroEmpresaFK=" + numeroEmpresaFK + "&numeroCartao=" + numeroCartao; 
        } else {
            urlProd = rotaDeProducao() +"/status?cnpj=" + cnpjConvertido + "&idTerminal=" + idTerminal + "&numeroEmpresaFK=" + numeroEmpresaFK; 
        }
        const data = await axios.get(urlProd);
        let json = data.data; 
        console.log("status da mesa")
        console.log(json)
        return json;
    } catch (e) {
        Swal.fire(numeroCartao+"\n"+e.response.data)
        console.log(e.response.data);
    }
}

/**
 * Envia o post com bloquear comanda
 * @param {String} cnpj 
 * @param {int} idTerminal 
 * @param {Object} body {"operacao":2,"NumeroCMS_FK":22, "idGarcons_FK":233,"codigoCentroResultado":42,"idCaixaLio":"72","numeroEmpresa_FK":30} 
 */
// export async function apiAbriuTelaConta(body) {
export async function apiBuscarItensDaConta(body) {
    try {
        const urlProd = rotaDeProducao() + "/contaitens";
        console.log("body") 
        console.log(body) 
        let res = await axios.post(urlProd, body);
        console.log("---------------------------------------- ** itens da conta ** ----------------------------------------")
        console.log(res.data)
        return res.data;
    } catch (e) {
        console.error(e);
        console.log(e.response.data)
        Swal.fire({
            title: "Erro ao buscar itens da conta",
            text: e.response.data,
        })
    }
}

/**
 * Envia o post com bloquear comanda
 * @param {String} cnpj 
 * @param {int} idTerminal 
 * @param {Object} body {"operacao":2,"NumeroCMS_FK":22, "idGarcons_FK":233,"codigoCentroResultado":42,"idCaixaLio":"72","numeroEmpresa_FK":30} 
 */
export async function apiAbriuTelaConta(body) {
    console.log(body)
    try {
        const urlProd = rotaDeProducao() + "/abriutelaconta"; 
        let res = await axios.post(urlProd, body);
        return res.data;
        
    } catch (e) {
        console.error("            deu merda")
        console.log(e);
        Swal.fire(e.response.data)
        console.log(e.response.data);
    }
}


/**
 * 
 * Envia o post com desbloquear comanda.
 * 
 * @param {String} cnpj 
 * @param {int} idTerminal 
 * @param {Object} body {"operacao":24,"NumeroCMS_FK":22, "idGarcons_FK":233,"codigoCentroResultado":42,"idCaixaLio":"72","numeroEmpresa_FK":30} 
 */
export async function apiFechouTelaConta(body) {
    console.log("fechar tela conta")
    console.log(body)
    try {
        // if (body.tipo == null) {
        //     throw "Tipo nulo, nao vai fazer nada"
        // }
        const urlProd = rotaDeProducao() + "/fechoutelaconta"; 
        let res = await axios.post(urlProd, body);
        return res.data;
        
    } catch (e) {
        console.error("            deu merda")
        console.log(e);
        Swal.fire(e.response.data)
        console.log(e.response.data);
    }
}


